import { checkIsDefined } from "./nullable.qwik.mjs";
import { getCookie, getCookieSync, setCookie } from "./cookie.qwik.mjs";
import { logger } from "./logger.qwik.mjs";
const BUILDER_STORE_PREFIX = "builder.tests";
const getContentTestKey = (id) => `${BUILDER_STORE_PREFIX}.${id}`;
const getContentVariationCookie = ({ contentId }) => getCookie({
  name: getContentTestKey(contentId),
  canTrack: true
});
const getContentVariationCookieSync = ({ contentId }) => getCookieSync({
  name: getContentTestKey(contentId),
  canTrack: true
});
const setContentVariationCookie = ({ contentId, value }) => setCookie({
  name: getContentTestKey(contentId),
  value,
  canTrack: true
});
const checkIsBuilderContentWithVariations = (item) => checkIsDefined(item.id) && checkIsDefined(item.variations) && Object.keys(item.variations).length > 0;
const getRandomVariationId = ({ id, variations }) => {
  var _a;
  let n = 0;
  const random = Math.random();
  for (const id2 in variations) {
    const testRatio = (_a = variations[id2]) == null ? void 0 : _a.testRatio;
    n += testRatio;
    if (random < n)
      return id2;
  }
  return id;
};
const getAndSetVariantId = (args) => {
  const randomVariationId = getRandomVariationId(args);
  setContentVariationCookie({
    contentId: args.id,
    value: randomVariationId
  }).catch((err) => {
    logger.error("could not store A/B test variation: ", err);
  });
  return randomVariationId;
};
const getTestFields = ({ item, testGroupId }) => {
  const variationValue = item.variations[testGroupId];
  if (testGroupId === item.id || // handle edge-case where `testGroupId` points to non-existing variation
  !variationValue)
    return {
      testVariationId: item.id,
      testVariationName: "Default"
    };
  else
    return {
      data: variationValue.data,
      testVariationId: variationValue.id,
      testVariationName: variationValue.name || (variationValue.id === item.id ? "Default" : "")
    };
};
const handleABTestingSync = ({ item, canTrack }) => {
  if (!canTrack)
    return item;
  if (!item)
    return void 0;
  if (!checkIsBuilderContentWithVariations(item))
    return item;
  const testGroupId = getContentVariationCookieSync({
    contentId: item.id
  }) || getAndSetVariantId({
    variations: item.variations,
    id: item.id
  });
  const variationValue = getTestFields({
    item,
    testGroupId
  });
  return {
    ...item,
    ...variationValue
  };
};
const handleABTesting = async ({ item, canTrack }) => {
  if (!canTrack)
    return item;
  if (!checkIsBuilderContentWithVariations(item))
    return item;
  const cookieValue = await getContentVariationCookie({
    contentId: item.id
  });
  const testGroupId = cookieValue || getAndSetVariantId({
    variations: item.variations,
    id: item.id
  });
  const variationValue = getTestFields({
    item,
    testGroupId
  });
  return {
    ...item,
    ...variationValue
  };
};
export {
  handleABTesting,
  handleABTestingSync
};
